import React from "react";
// import { useTransition, config, animated } from "react-spring";
// import { createUseStyles } from "react-jss";
// import Hmm from "./views/Hmm";
import Home from "./Main";

export default function App() {
  return (
    <>
      {/* <Hmm /> */}
      <Home />
    </>
  );
}
